<template>
  <div>
    <v-client-table :columns="columns" :data="usersWithId" :options="options" :theme="theme" id="dataTable">
      <div slot="afterLimit" class="card-header-actions">
        <download-excel
          class   = "btn btn-default"
          type    = "csv"
          name    = "users.xls"
          :fetch   = "fetchForExcel">
            <i class="fa fa-file-excel-o"></i>
        </download-excel>
      </div>
      <div slot="email" slot-scope="props">
        <router-link :to="{name: 'User', params: {id: props.row.id}}">{{props.row.email}}</router-link>
      </div>
      <b-button pill variant="outline-light" size="sm" slot="delete" slot-scope="props" @click.stop="confirmDelete(props.row)">
        <i class="fa fa-trash"></i>
      </b-button>
      <div slot="child_row" slot-scope="props">
        User ID : {{props.row.id}} &nbsp;&nbsp;
        <b-button v-if="props.row.disabled" pill variant="info" size="sm"  @click.stop="confirmEnable(props.row)">Cancel Disabled</b-button>
      </div>
    </v-client-table>

    <b-modal title="Delete User" class="modal-warning" v-model="warningModal" @ok="deleteItem" ok-variant="warning">
      Group and devices related this user also will be affected?  Are you sure to delete?
    </b-modal>

    <b-modal title="Update State" class="modal-warning" v-model="enableModal" @ok="cancelDisable" ok-variant="warning">
      Are you sure to make normal state?
    </b-modal>    
  </div>
</template>

<script>
  import { ClientTable, Event } from 'vue-tables-2'

  export default {
    name: 'Users',
    components: {
      ClientTable,
      Event,
    },
    props: {
      hasDevice: {
        type: String,
        required: false,
      },
      groupTo: {
        type: String,
        required: false,
      },
      searchOption: {
        type: Object,
        required: false,
      }
    },
    data: function() {
      return {
        idToDelete : null,
        enableModal: false,
        warningModal: false,
        users: [],
        columns: ['email', 'displayName', 'occupation', 'organization', 'country', 'hasDevicesSize', 'created', 'updated', 'delete'],
        options: {
          headings: {
            email: 'E Mail',
            displayName: 'DisplayName',
            occupation: 'Occupation',
            organization: 'Organization',
            country: 'Country',
            hasDevicesSize: 'Devices',
            created: 'Created',
            updated: 'Updated',
            emailVerified: 'Email Verified',
            delete: 'Delete'
          },
          sortable: ['email', 'displayName', 'occupation', 'organization', 'country', 'hasDevicesSize', 'created', 'updated'],
          filterable: ['email', 'displayName', 'occupation', 'organization', 'country', 'hasDevicesSize', 'created', 'updated'],
          sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
          templates: {
            emailVerified: (h, row, index) => {
                return row.emailVerified ? 'Y': 'N'
            },
            created: (h, row, index) => {
                return (row.created && row.created.seconds) ?this.$moment.unix(row.created.seconds).format('YYYY-MM-DD HH:mm:ss'): '';
            },
            updated: (h, row, index) => {
                return (row.updated && row.updated.seconds) ?this.$moment.unix(row.updated.seconds).format('YYYY-MM-DD HH:mm:ss'): '';
            }
          },
          pagination: {
            chunk: 5,
            edge: false,
            nav: 'scroll'
          }
        },
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default'
      }
    },
    created: function() {
      this.bindFirestore()
    },
    computed: {
      usersWithId() {
        if (!this.users || this.users.length < 1) {
            return []
        }
        return this.users.map(user => {
            return {...user, id: user.id}
        })
      },
    },
    watch: {
      '$route': 'bindFirestore'
    },
    methods: {
        bindFirestore() {
          let query = this.$firebase.firestore().collection('users')

      if (this.groupTo) {
            query = query.where('groupTo', '==', this.$firebase.firestore().collection('groups').doc(this.groupTo))
      } 
      if (this.hasDevice) {
            query = query.where('hasDevices', 'array-contains', this.$firebase.firestore().collection('devices').doc(this.hasDevice))
      }
      if (this.searchOption) {
            if (typeof this.searchOption.disabled === 'boolean') {
          query = query.where('disabled', '==', this.searchOption.disabled)
        }
            if (typeof this.searchOption.emailVerified === 'boolean') {
          query = query.where('emailVerified', '==', this.searchOption.emailVerified)
        }
        if (this.searchOption.hasDevice === false) {
          query = query.where('hasDevicesSize', '==', 0)
        }
            if (this.searchOption.createdFrom && this.searchOption.createdTo) {
          query = query
          .where('created', '>=', this.$moment(this.searchOption.createdFrom, 'YYYY-MM-DD').startOf('day').toDate())
          .where('created', '<=', this.$moment(this.searchOption.createdTo, 'YYYY-MM-DD').endOf('day').toDate())
        }
      }
      query = query.orderBy('created', 'desc').limit(1000)
          this.$bind('users', query).then((users)=> {
            console.log('users bind done ')
            })
        },
        fetchForExcel() {
          if (!this.users || this.users.length < 1) {
              return []
          }
          return this.users.map(user => {
              delete user.passwordHash;
              delete user.encryptKey;
              delete user.groupTo;
              delete user.hasDevices;
              return user;
          })
        },
        confirmEnable(item, event) {
          if (!item) {
            return
          }
          this.selectedItem = item
          this.idToDelete = item.id
          this.enableModal = true
        },
        confirmDelete(item) {
          if (!item) {
            return
          }
          this.idToDelete = item.id
          this.warningModal = true
        },
        deleteItem() {
          if (!this.idToDelete) return

          const userRef = this.$firebase.firestore().collection('users').doc(this.idToDelete)
          this.warningModal = false
          return userRef.delete()
          .catch(error => {
            console.error('delete error: ', error)
          })
        },
        cancelDisable() {
          if (!this.idToDelete) return
          const userRef = this.$firebase.firestore().collection('users').doc(this.idToDelete)
          this.enableModal = false
          return userRef.update({disabled: false, updated: this.$firebase.firestore.FieldValue.serverTimestamp()})
          .catch(error => {
            console.error('update error: ', error)
          })
        }
    }
  };
</script>

<style lang="scss">
  #dataTable {
    width: 95%;
    margin: 0 auto;

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .vue-title {
      text-align: center ;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      display: flex;
    }
    .VueTables__search-field input {
      margin-left: 0.25rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table th {
      text-align: center;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
      content: "+";
    }

    .VueTables__child-row-toggler--open::before {
      content: "-";
    }
  }

</style>
